import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Money } from 'ha/services/apiV2/types/common';
import {
  Settlement,
  SettlementExternalRefType,
} from 'ha/services/apiV2/types/Settlement';
import { APIV2_URL } from '../constants';

export type Payload = {
  senderAccountUuid: string;
  recipientAccountUuid: string;
  externalReferenceType: SettlementExternalRefType;
  externalReference: string;
  purchaseValue: Money;
};

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Settlement>('POST', `${APIV2_URL}/payment/settlement`, { data });
